// extracted by mini-css-extract-plugin
export default {"fullWidth":"OE-z","image":"PE-z","lazyLoadPicture":"QE-z","lazyLoadSpinner":"RE-z","lazyLoadSpin":"SE-z","lazyLoadImage":"TE-z","hasStyledAspectRatio":"UE-z"};